// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1792378325067
      var cssReload = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  